import { makeEnum } from '@transcend-io/type-utils';

/**
 * The supported option on conditional expression
 */
export const SupportedConditionals = makeEnum({
  Or: 'Or',
  And: 'And',
});

/** Override type */
export type SupportedConditionals =
  (typeof SupportedConditionals)[keyof typeof SupportedConditionals];
